var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgReverification(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14z",
    fill: "#FFC859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16a14 14 0 01-14 14V2a14 14 0 0114 14z",
    fill: "#FA9C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.994 8.347l-.594.588a.593.593 0 01-.84 0 10.786 10.786 0 00-7.504-3.208 10.192 10.192 0 00-9.576 6.647c-.137.408-.252.823-.347 1.243a.588.588 0 00.56.722h2.24a.588.588 0 00.56-.37c.306-.837.712-1.634 1.21-2.374a6.82 6.82 0 0110.421-.23.6.6 0 010 .824l-.56.532a.588.588 0 00.476 1.036h4.357a.587.587 0 00.593-.588V8.795a.594.594 0 00-.996-.448zM7.006 23.64l.588-.56a.6.6 0 01.84 0 10.796 10.796 0 007.51 3.181 10.191 10.191 0 009.34-6.115c.226-.575.413-1.165.56-1.764a.587.587 0 00-.56-.734h-2.228a.6.6 0 00-.56.437 6.86 6.86 0 01-6.552 4.844 7.195 7.195 0 01-5.258-2.139.558.558 0 010-.829l.688-.694a.588.588 0 00-.414-1.03H6.603a.594.594 0 00-.593.587v4.374a.588.588 0 00.996.442z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgReverification;